import type { ITOALayout } from './TOALayout'

import { styled } from '@linaria/react'
import { TextBoxSC } from 'atoms/TextBox'
import { FIXED_INDENTS, MEDIA } from 'vars/index'

export const TOALayoutSC = styled.div<Omit<ITOALayout, 'children'>>`
  display: flex;
  flex-direction: column;
  padding: ${({ paddings }) =>
    paddings?.length
      ? paddings.map((padding) => `var(${padding})`).join(' ')
      : 0};
  background: ${({ background }) => `var(${background})`};

  & ${TextBoxSC}:nth-child(2) {
    padding: var(${FIXED_INDENTS.INDENT_40}) 0 var(${FIXED_INDENTS.INDENT_20});

    ${MEDIA.MIN_1240} {
      padding: var(${FIXED_INDENTS.INDENT_70}) 0 var(${FIXED_INDENTS.INDENT_20});
    }
  }

  & ${TextBoxSC} {
    white-space: pre-wrap;
  }
`
